// extracted by mini-css-extract-plugin
export var active = "Nav-module--active--5c546";
export var button = "Nav-module--button--0a04b";
export var documentNav = "Nav-module--documentNav--a7716";
export var mainNav = "Nav-module--mainNav--42211";
export var menuButton = "Nav-module--menuButton--9e2ae";
export var navSquish = "Nav-module--navSquish--4fe38";
export var navbarLeftText = "Nav-module--navbarLeftText--1ebd7";
export var navbarLogo = "Nav-module--navbarLogo--6b6e8";
export var navbarRight = "Nav-module--navbarRight--72df9";
export var navbarRightHider = "Nav-module--navbarRightHider--a1b2d";
export var navbarTop = "Nav-module--navbarTop--c07e8";